import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errorMessage } from "@/lib/errors";

/** Replaces the spinner-forever failure mode of the old pages. */
export default function ErrorState({ error, onRetry, className = "" }) {
  return (
    <div className={`bg-white rounded-2xl shadow-sm p-8 text-center ${className}`}>
      <AlertCircle className="h-10 w-10 text-red-400 mx-auto mb-3" />
      <p className="text-gray-700 font-medium mb-1">Something went wrong</p>
      <p className="text-sm text-gray-500 mb-4">{errorMessage(error)}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} className="gap-2">
          <RefreshCw className="h-4 w-4" /> Try again
        </Button>
      )}
    </div>
  );
}
